export const sanitizePostalInput = (value: string): string => {
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9\s,-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const normalizePostalCode = (
  postalCode?: string
): string | undefined => {
  if (!postalCode) return undefined;

  const value = sanitizePostalInput(postalCode);
  if (!value || !/\d/.test(value)) {
    return undefined;
  }

  const compact = value.replace(/[\s-]/g, '');
  if (compact.length < 3 || compact.length > 10) {
    return undefined;
  }

  if (compact.length === 6 && /[A-Z]/.test(compact)) {
    return `${compact.slice(0, 3)} ${compact.slice(3)}`;
  }

  return value;
};

export const extractPostalCodeFromText = (
  value?: string
): string | undefined => {
  if (!value) return undefined;

  const cleaned = sanitizePostalInput(value);
  if (!cleaned) return undefined;

  const tokens = cleaned.split(/[\s,]+/).filter(Boolean);
  const candidates = [
    tokens.at(-1),
    tokens.length >= 2 ? `${tokens.at(-2)} ${tokens.at(-1)}` : undefined,
    cleaned,
  ];

  for (const candidate of candidates) {
    const normalized = normalizePostalCode(candidate);
    if (normalized) return normalized;
  }

  return undefined;
};
